import { Modal } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PLAN_ACCESS_EVENT, parsePlanAccessNotice, PlanAccessNotice as Notice } from '../../helpers/PlanAccessNotice'

export function PlanAccessNotice (): React.ReactElement {
  const [notice, setNotice] = useState<Notice | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const receive = (event: Event): void => {
      if (!('detail' in event)) return
      const next = parsePlanAccessNotice(event.detail)
      if (next) setNotice(current => current ?? next)
    }
    window.addEventListener(PLAN_ACCESS_EVENT, receive)
    return () => window.removeEventListener(PLAN_ACCESS_EVENT, receive)
  }, [])

  return (
    <Modal
      open={notice !== null}
      title={notice?.code === 'PLAN_LIMIT_REACHED' ? 'Limite do plano atingido' : 'Recurso disponível em outro plano'}
      okText='Ver planos'
      cancelText='Voltar'
      onCancel={() => setNotice(null)}
      onOk={() => {
        const resource = notice?.feature ?? notice?.resource
        setNotice(null)
        navigate(`/checkout${resource ? `?recurso=${encodeURIComponent(resource)}` : ''}`)
      }}
    >
      <p>{notice?.message}</p>
      <p>Consulte os planos e os recursos incluídos antes de escolher uma alteração.</p>
    </Modal>
  )
}
